import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const ComponentIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 2L17 7L12 12L7 7L12 2ZM17 12L22 17L17 22L12 17L17 12ZM7 12L12 17L7 22L2 17L7 12Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

ComponentIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(ComponentIcon);
